import React, { useState } from "react";
import "./Gallery.css";
import profile from "../../../Assets/newAsset/profile.webp";
import boxwater from "../../../Assets/newAsset/boxwater.webp";
import food from "../../../Assets/newAsset/food.webp";
//importing CARASOUL
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { LazyLoadImage } from 'react-lazy-load-image-component';


//RESPONSIVE SCRRREN
const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 3,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};
const img = [
  {
    id: 12,
    img: profile,
  },
  {
    id: 32,
    img: boxwater,
  },
  {
    id: 31,
    food,
  },
  {
    id: 41,
    img: boxwater,
  },
  {
    id: 51,
    img: food,
  },
];

 
 
const vidio = [
  "https://www.youtube.com/embed/2-Ne8pwV0VQ?rel=0",
  "https://www.youtube.com/embed/1GAwzyiy1r4?rel=0",

  "https://www.youtube.com/embed/CrhyyfJpUs8?rel=0",

  "https://www.youtube.com/embed/P0MRhFxjD8E?rel=0" ,
  "https://www.youtube.com/embed/roCdNXyvtF8?rel=0",
  "https://www.youtube.com/embed/Xa8OMq138g8?rel=0",
  "https://www.youtube.com/embed/dLKEzXAbclo?rel=0",
  "https://www.youtube.com/embed/bm8aW3Rv2SY?rel=0",
  "https://www.youtube.com/embed/F7cSJj3YdCk?rel=0",
];

function Gallery() {
  const [isPhotoActive, setPhotoActive] = useState(false);
  const [isVidioActive, setVidioActive] = useState(true);

  const togglePhoto = () => {
    setPhotoActive(false);
    setVidioActive(true);
  };

  const toggleVideo = () => {
    setPhotoActive(true);
    setVidioActive(false);
  };

  return (
    <div className="toogleBetween">
      {/* <div className="toggleHeader">
        <div className="toggleButtons">
          <span
            className={isPhotoActive ? "activeButton" : null}
            onClick={togglePhoto}
          >
            Photos
          </span>
          <span
            className={isVidioActive ? "activeButton" : null}
            onClick={toggleVideo}
          >
            Videos
          </span>
        </div>
      </div> */}
      <div className="GalleryRow">
        <Carousel
          swipeable={true}
          draggable={false}
          showDots={false}
          responsive={responsive}
          ssr={true} // means to render carousel on server-side.
          infinite={true}
          autoPlay={true}
          autoPlaySpeed={4500}
          transitionDuration={300}
          deviceType={"tablet"}
        >
          {isPhotoActive
            ? img.map((values, index) => (
                <div className="gallery__img" key={values.id}>
                  <LazyLoadImage src={values.img} alt={values} delayTime='100' />

                </div>
              ))
            : vidio.map((values, index) => (
                <div className="gallery__video" key={index}>
                  <iframe
                    className="gallVid"
                    
                    src={values}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
               
              ))}
        </Carousel>
      </div>
    </div>
  );
}

export default Gallery;
